import { TextLayer } from '@deck.gl/layers';
import type { Feature, GeoJsonProperties, Geometry } from 'geojson';
import chroma, { Color } from 'chroma-js';
import { FrontendGeoJsonFeature } from '../../types/global';

export default function textLayer(wardData: FrontendGeoJsonFeature[]) {
  const householdCounts = wardData.filter((feature) => feature.properties?.householdCount).map((feature) => Number(feature.properties?.householdCount) || 0);

  const minimumHouseholdCount = Math.min(...householdCounts);
  const maximumHouseholdCount = Math.max(...householdCounts);
  return new TextLayer({
    id: 'text-layer',
    data: wardData as GeoJsonProperties & Feature<Geometry, GeoJsonProperties>[],
    getPosition: (feature: Feature) => [Number(feature.properties?.longitude), Number(feature.properties?.latitude)],
    getText: (feature: Feature) => feature.properties?.householdCount?.toString(),
    getSize: 10,
    getColor: [0, 0, 0],
    background: true,
    getBackgroundColor: (feature: Feature) => {
      if (!feature.properties) return [196, 205, 213, 128];
      const count = Number(feature.properties.householdCount) || 0;
      const colourScale = chroma.scale('Oranges').mode('lch').domain([Math.log(minimumHouseholdCount), Math.log(maximumHouseholdCount)]);
      const colour: Color = colourScale(Math.log(count));
      const rgba = colour.rgba();
      rgba[3] = 255;
      return rgba;
    },
    backgroundBorderRadius: 4,
    backgroundPadding: [2, 2],
    getTextAnchor: 'middle',
    getAlignmentBaseline: 'center',
    getAngle: 10,
    pickable: false,
  });
}
